<template>
  <div class="space-requirements">
    <div class="space-requirements--title">
      {{$store.getters.language.book_require}}
    </div>
    <div class="space-requirements--description">
        <div class="check-item">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6.5L5.5 8L8.5 4" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 1H3C1.89543 1 1 1.89543 1 3V9C1 10.1046 1.89543 11 3 11H9C10.1046 11 11 10.1046 11 9V3C11 1.89543 10.1046 1 9 1Z" stroke="#4D4D4D"/>
          </svg>
          <span class="check-label">{{$store.getters.language.insurance}}</span>
        </div>
        <div class="check-item">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6.5L5.5 8L8.5 4" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 1H3C1.89543 1 1 1.89543 1 3V9C1 10.1046 1.89543 11 3 11H9C10.1046 11 11 10.1046 11 9V3C11 1.89543 10.1046 1 9 1Z" stroke="#4D4D4D"/>
          </svg>
          <span class="check-label">{{$store.getters.language.ex_image}}</span>
        </div>
        <div class="check-item">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6.5L5.5 8L8.5 4" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 1H3C1.89543 1 1 1.89543 1 3V9C1 10.1046 1.89543 11 3 11H9C10.1046 11 11 10.1046 11 9V3C11 1.89543 10.1046 1 9 1Z" stroke="#4D4D4D"/>
          </svg>
          <span class="check-label">{{$store.getters.language.pay_method}}</span>
        </div>
    </div>
  </div>
</template>

<script>
import Checkbox from "./filters/Checkbox";
export default {
  name: 'SpacesRequirements',
  data: () => ({
  }),
  props: [],
  components: {
      Checkbox
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";

.input--checkbox{
  border: none;
  color: $primary-grey;
}

.check-item{
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.input--checkbox:checked {
  border: none;
  outline: 2px solid $primary-grey;
  background-color: white;
}

.check-label{
  vertical-align:middle
}

.space-requirements {
  width: 100%;
  background: $light-grey;
  color: $primary-grey;
  padding: 32px;
  border-radius: 4px;
}
.space-requirements--title {
  width: 100%;
  display: block;
  @include responsive-text-size('Header--13--BOLD');
  padding-bottom: 16px;
  margin-bottom: 19px;
  border-bottom: 1px solid $divider-dark;
}
.space-requirements--description {
  width: 100%;
  display: block;
}

</style>
